export * from './directives/NgGrid';
export * from './directives/NgGridItem';
export * from './components/NgGridPlaceholder';
export * from './interfaces/INgGrid';
export * from './modules/NgGrid.module';
//# sourceMappingURL=main.js.map


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/angular2-grid/main.js
// module id = oC2T
// module chunks = 3